import React from 'react'
import { withRouter } from 'react-router-dom'
import './article-button.css'

class ArticleButton extends React.Component {
    constructor(props) {
        super(props)
        this.state={

        }
    }
    handleToId = () => {
        this.props.history.push('/article/' + this.props._id)
    }
    render() {
        return(
            <div className='result' onClick={this.handleToId}>
                <p className='date'>{this.props.date}&nbsp;{this.props.auther}</p>
                <p className='title'>{this.props.title}</p>
            </div>
        )
    }
}

export default withRouter(ArticleButton)